const state = {
    title: '',
    parent: null,
    buttons: []
}

const getters = {
    title: state => state.title,
    parent: state => state.parent,
    buttons: state => state.buttons
}

const mutations = {
    setTitle: (state, title) => {
        state.title = title
    },

    setParent: (state, parent) => {
        state.parent = parent
    },

    addToolbarButton: (state, btn) => {
        state.buttons.push(btn)
    },

    resetToolbarButtons: (state) => {
        state.buttons = []
    }
}

export default {
    state,
    getters,
    mutations
}